import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDBetRecordSummary implements ICommand
{

	public ReportTime : number = 0;
	public FGameID : bigint = 0n; 
	public GameID : number = 0;
	public HostID : number = 0;
	public GameCount : number = 0;
	public GameType : number = 0;
	public State : number = 0;
	public Result : string = "";
	public WinSlot : number = 0;
	public BetAmount : number = 0;
	public RollingAmount : number = 0;
	public ResultAmount : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ReportTime = ba.readInt53();
		this.FGameID = ba.readUint64();
		this.GameID = Number(this.FGameID);
		this.HostID = ba.readUint16();
		this.GameCount = ba.readUint32();
		this.GameType = ba.readInt53();
		this.State = ba.readUint8();
		this.Result = ba.readString();
		this.WinSlot = ba.readInt53();
		this.BetAmount = ba.readInt53();
		this.RollingAmount = ba.readInt53();
		this.ResultAmount = ba.readInt53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.ReportTime);
		ba.writeUint64(this.FGameID);
		ba.writeUint16(this.HostID);
		ba.writeUint32(this.GameCount);
		ba.writeUint53(this.GameType);
		ba.writeUint8(this.State);
		ba.writeString(this.Result);
		ba.writeUint53(this.WinSlot);
		ba.writeUint53(this.BetAmount);
		ba.writeUint53(this.RollingAmount);
		ba.writeUint53(this.ResultAmount);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDBetRecordSummary();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ReportTime(Q)='+this.ReportTime+' ';
		str += 'GameID(F)='+this.GameID+' ';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameCount(D)='+this.GameCount+' ';
		str += 'GameType(Q)='+this.GameType+' ';
		str += 'State(B)='+this.State+' ';
		str += 'Result(S)='+this.Result+' ';
		str += 'WinSlot(Q)='+this.WinSlot+' ';
		str += 'BetAmount(Q)='+this.BetAmount+' ';
		str += 'RollingAmount(Q)='+this.RollingAmount+' ';
		str += 'ResultAmount(Q)='+this.ResultAmount+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'BetRecordSummary';
	}

}
